import { render } from "./EventsDates.vue?vue&type=template&id=1b40741f"
import script from "./EventsDates.vue?vue&type=script&lang=js"
export * from "./EventsDates.vue?vue&type=script&lang=js"

import "./EventsDates.vue?vue&type=style&index=0&id=1b40741f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__